import getPathReduxUtil from 'modules/redux/utils/get-path'
import { REFERENCES_DOMAIN } from 'modules/training/modules/references/constants'
import getReferencesSelector from 'modules/training/modules/references/selectors/get'
import {
  getObjectUtil,
  omitObjectUtil
} from 'packages/src'

function removeReferenceUtil (params) {
  const {
    state,
    instance,
    referencePath
  } = params
  const domain = getObjectUtil(state, REFERENCES_DOMAIN)
  const path = getPathReduxUtil(instance)
  const references = getReferencesSelector(path)(state)
  // // console.debug(`removeReferenceUtil: path ${path}, referencePath ${referencePath}, references ${references}`)
  if (!references.includes(referencePath)) {
    return
  }
  // Remove the new `referencePath`
  const newReferences = references.filter(
    reference => reference !== referencePath
  )
  let newDomain
  if (newReferences.length) {
    newDomain = {
      ...domain,
      [path]: newReferences
    }
  } else {
    newDomain = omitObjectUtil(domain, [path])
  }
  return newDomain
}

export default removeReferenceUtil
